import React from 'react';
import Select from 'react-select';
import {rule_selector,operator_selector,rule_settings} from './constants';
import Tooltip from 'rc-tooltip';

import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import moment from 'moment';


import Text from './Rules/Text.js';
import ProductPicker from './Rules/ProductPicker.js';
import ManufacturerPicker from './Rules/ManufacturerPicker.js';
import CategoryPicker from './Rules/CategoryPicker.js';
import NumberPicker from './Rules/NumberPicker.js';
import DayPicker from './Rules/DayPicker.js';
import GenderPicker from './Rules/GenderPicker.js';
import PopupPicker from './Rules/PopupPicker.js';


const components = {
    GenderPicker,
    Text,
    DayPicker,
    NumberPicker,
    ProductPicker,
    ManufacturerPicker,
    CategoryPicker,
    PopupPicker,
};


class Rule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            initialStart:moment(moment().subtract(30, 'days')),
            initialEnd:moment(),
            focusedInput:null,
            lastValidation:true,
        };

        this.renderValuePicker = this.renderValuePicker.bind(this);
        this.handleLimitCheckbox = this.handleLimitCheckbox.bind(this);
        this.parseDate = this.parseDate.bind(this);
        this.onFocusChange = this.onFocusChange.bind(this);
        this.onDatesChange = this.onDatesChange.bind(this);
        this.handleAndCheckbox = this.handleAndCheckbox.bind(this);
        this.renderAndTooltip = this.renderAndTooltip.bind(this);
        this.relative_text = this.relative_text.bind(this);
        this.handleRelativeCheckbox = this.handleRelativeCheckbox.bind(this);
        this.handleRealtiveChange = this.handleRealtiveChange.bind(this);
        this.drawAndOption = this.drawAndOption.bind(this);
    }

    drawAndOption() {
        if(rule_settings[this.props.rule.key].has_and !== true) {
            return false;
        }

        if(rule_settings[this.props.rule.key].hide_and_rule === true && this.props.rule.operator == '!=') {
            return false;
        }

        return (
            <Tooltip placement="top" overlay={<span>{this.renderAndTooltip()}</span>}>
                <div className="checkbox-custom checkbox-primary">
                    <input type="checkbox" id={`${this.props.rule.id}-and-checkbox`} checked={this.props.rule.is_and} onChange={this.handleAndCheckbox} /><label htmlFor={`${this.props.rule.id}-and-checkbox`}> Rule must match all values</label>
                </div>
            </Tooltip>
        )
    }

    handleRealtiveChange(a,b,value) {
        this.props.handleRuleChange(this.props.index,'relative',value);
    }

    relative_text() {
        let html = [];

        rule_settings[this.props.rule.key].relative_text.split('%').map((item,index) => {
            if(item == 'days') {
                html.push(
                    <div key={index}  style={{width:'100px',marginTop:'-7px',marginRight:'5px',float:'left',lineHeight:'32px',display:'inline-block'}}><DayPicker disabled={this.props.rule.use_relative == '0' || this.props.rule.use_relative == '' || !this.props.rule.use_relative ? true:false} rule={{value:this.props.rule.relative == 0 || this.props.rule.relative == '' || !this.props.rule.relative ? 30:this.props.rule.relative}} index={0} handleRuleChange={this.handleRealtiveChange} /></div>
                );
            }else{
                html.push(<div style={{marginTop:'-7px',marginRight:'5px',float:'left',lineHeight:'36px',display:'inline-block'}} key={index}>{item}</div>);
            }
        })

        return html;

    }

    parseDate(d,type) {
        if(typeof d === 'string') {
            if(moment(d, 'YYYY-MM-DD HH:mm:ss').isValid()) {
                d = moment(d);
            }
        }


        return d;
    }

    validate() {
        const validation = rule_settings[this.props.rule.key].validate(this.props.rule,this.props.rules);

        if(this.state.lastValidation != validation) {
            if(validation !== true) {
                this.props.handleRuleError(true,this.props.rule.id,validation);
            }else{
                this.props.handleRuleError(false,this.props.rule.id,true);
            }

            this.setState({
                lastValidation:validation
            });
        }

        return validation !== true ? false:true;
    }

    componentDidMount() {
        this.validate();
    }

    componentDidUpdate() {
        this.validate();
    }

    renderAndTooltip() {
        let str = `Currently matching`;

        if (typeof this.props.rule.value != 'object') {
            return `${str} nothing`;
        }

        if(this.props.rule.value.length == 0) {
            return `${str} nothing`;
        }


        let spacing = this.props.rule.is_and == 1 ? 'AND':'OR';

        return (
            <span>
                Currently matching &nbsp;
                <span>
                    {this.props.rule.value
                        .map((t,i) => <span key={`and-name-${t.id}`}>{t.name}</span>)
                        .reduce((prev, curr) => [prev, <strong key={`and-bold-${prev.id}`}> {spacing} </strong>, curr])}
                </span>
            </span>
        )
    }


    handleLimitCheckbox(e) {
        let value = false;

        if(e.target.checked) {
            value = true;
        }

        this.props.handleRuleChange(this.props.index,'use_limit',value);
        this.props.handleRuleChange(this.props.index,'from',null);
        this.props.handleRuleChange(this.props.index,'to',null);
    }

    handleAndCheckbox(e) {
        let value = false;

        if(e.target.checked) {
            value = true;
        }

        this.props.handleRuleChange(this.props.index,'is_and',value);
    }

    handleRelativeCheckbox(e) {
        let value = false;

        if(e.target.checked) {
            value = true;
        }

        this.props.handleRuleChange(this.props.index,'use_relative',value);
    }

    onDatesChange({ startDate, endDate }) {
        if(startDate) {
            this.props.handleRuleChange(this.props.index,'from',startDate.format('YYYY-MM-DD HH:mm:ss'));
        }
        if(endDate) {
            this.props.handleRuleChange(this.props.index,'to',endDate.format('YYYY-MM-DD HH:mm:ss'));
        }

    }

    onFocusChange(focusedInput) {
        this.setState({ focusedInput });
    }

    renderValuePicker() {
        const Comp = components[rule_settings[this.props.rule.key].value_type];
        return <Comp handleRuleChange={(index,operator,value) => this.props.handleRuleChange(this.props.index,'value',value)} rule={this.props.rule} index={this.props.index} key={this.props.rule.id} />
    }
    
    render() {

        let borderColor = {
            border:this.state.lastValidation !== true ? '1px solid #f96868':'1px solid #e4eaec'
        }


        return (
            <li className="timeline-item timeline-reverse">
                <div className="timeline-dot bg-blue-grey-800">
                    <i className="icon wb-chevron-right" aria-hidden="true"></i>
                </div>
                <div className="timeline-content text-left">
                    <div className="card card-article card-shadow" style={borderColor}>

                        {this.state.lastValidation !== true ? <div style={{position: 'absolute',
                            top: '-15px',
                            left: '20px',
                            borderRadius: '4px',
                            backgroundColor: '#f96868',
                            color: '#fff',
                            padding: '3px',
                            paddingLeft:'10px',
                            paddingRight:'10px'}}>{this.state.lastValidation}</div>:null}

                        <div className="card-block">
                            <div className="col-sm-12">
                                <div className="col-sm-5">
                                    <Select
                                        allowCreate={false}
                                        searchable={false}
                                        clearable={false}
                                        name="form-field-name"
                                        value={this.props.rule.key}
                                        options={rule_selector()}
                                        onChange={(e) => this.props.handleRuleChange(this.props.index,'key',e.value)}
                                    />
                                </div>
                                <div className="col-sm-3">
                                    <Select
                                        allowCreate={false}
                                        searchable={false}
                                        clearable={false}
                                        name="form-field-name"
                                        value={this.props.rule.operator}
                                        options={operator_selector(this.props.rule.key)}
                                        onChange={(e) => this.props.handleRuleChange(this.props.index,'operator',e.value)}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    {this.renderValuePicker()}
                                </div>

                                <hr style={{
                                    clear: 'both',
                                    marginTop: '50px',
                                    marginBottom:' 9px',
                                }}/>

                                <div className="col-sm-12">

                                    <div className="col-sm-10 p-0">
                                        {rule_settings[this.props.rule.key].date_range && this.props.exportable == '1' ?
                                        <div className="col-sm-4 p-0">
                                                <div className="checkbox-custom checkbox-primary">
                                                <input type="checkbox" id={`${this.props.rule.id}-checkbox`} checked={this.props.rule.use_limit} onChange={this.handleLimitCheckbox} /><label htmlFor={`${this.props.rule.id}-checkbox`}> Limit condition by date range</label>
                                            </div>
                                        </div>:null}

                                        {rule_settings[this.props.rule.key].has_relative === true && this.props.exportable != '1' ?
                                            <div className="col-sm-12 p-0">
                                                <div className="checkbox-custom checkbox-primary">
                                                    <input style={{float:'left'}} type="checkbox" id={`${this.props.rule.id}-relative-checkbox`} checked={this.props.rule.use_relative} onChange={this.handleRelativeCheckbox} />

                                                    <label style={{float:'left'}} htmlFor={`${this.props.rule.id}-relative-checkbox`}></label>
                                                    <div style={{float:'left',marginLeft:'10px'}}>
                                                        {
                                                            this.relative_text()
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        :null}




                                        {
                                            this.props.rule.use_limit && rule_settings[this.props.rule.key].date_range ?
                                                <div className="col-sm-8 p-0">
                                                    <DateRangePicker
                                                        onDatesChange={this.onDatesChange}
                                                        onFocusChange={this.onFocusChange}
                                                        focusedInput={this.state.focusedInput}
                                                        startDateId="start_date"
                                                        endDateId="end_date"
                                                        small={true}
                                                        startDate={this.parseDate(this.props.rule.from,'from')}
                                                        endDate={this.parseDate(this.props.rule.to,'to')}
                                                        isOutsideRange={() => {return false}}
                                                        anchorDirection="left"
                                                        showDefaultInputIcon
                                                    />
                                                </div>:null
                                        }

                                        <div className="col-sm-4 p-0">
                                            {this.drawAndOption()}
                                        </div>
                                    </div>

                                    <div className="card-actions pull-xs-right">
                                        <a onClick={(e) => this.props.remove(this.props.rule.id)} href="javascript:void(0)">
                                            <i className="icon wb-trash" aria-hidden="true"></i>
                                        </a>
                                    </div>

                                </div>
                            </div>









                        </div>
                    </div>
                </div>
            </li>
        )
    }


}

export default Rule;




// WEBPACK FOOTER //
// ./containers/segments/Rule.js